/*
  Moya design studio: build an engraving from text, drawing, line stickers, emoji and an uploaded image.
  Everything is drawn into one engraving area (the space below the label on the back of the bottle).
  window.MoyaStudio.open(opts) opens the editor; window.MoyaStudio.build(state, opts) makes the files.
  opts: { back: url, front: url, zone: { top, h, w } (percent of the packshot), state, onDone(result) }
*/
(function () {
  if (window.MoyaStudio) return;
  var D = document, W = window;
  var MARGIN = 0.14;
  var uid = 0;
  function nid() { return 'o' + (++uid) + Date.now().toString(36); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function el(tag, attrs, html) { var e = D.createElement(tag); if (attrs) for (var k in attrs) { if (k === 'class') e.className = attrs[k]; else e.setAttribute(k, attrs[k]); } if (html != null) e.innerHTML = html; return e; }
  function canvas(w, h) { var c = D.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }

  /* ---------- Stickers: simple line icons that engrave cleanly (24 x 24 grid) ---------- */
  function C(x, y, r) { return 'M' + (x - r) + ' ' + y + 'a' + r + ' ' + r + ' 0 1 0 ' + 2 * r + ' 0a' + r + ' ' + r + ' 0 1 0 ' + -2 * r + ' 0'; }
  function star() { var p = ''; for (var i = 0; i < 10; i++) { var a = -Math.PI / 2 + i * Math.PI / 5, r = i % 2 ? 4.1 : 9.6; p += (i ? 'L' : 'M') + (12 + r * Math.cos(a)).toFixed(2) + ' ' + (12.8 + r * Math.sin(a)).toFixed(2); } return p + 'z'; }
  function sun() { var p = C(12, 12, 4.2); for (var i = 0; i < 8; i++) { var a = i * Math.PI / 4; p += 'M' + (12 + 6.6 * Math.cos(a)).toFixed(2) + ' ' + (12 + 6.6 * Math.sin(a)).toFixed(2) + 'L' + (12 + 9.6 * Math.cos(a)).toFixed(2) + ' ' + (12 + 9.6 * Math.sin(a)).toFixed(2); } return p; }
  function wave() { var p = ''; [9, 15].forEach(function (y) { for (var x = 2; x <= 22; x += 0.5) p += (x === 2 ? 'M' : 'L') + x + ' ' + (y + 2.2 * Math.sin((x - 2) / 20 * Math.PI * 2)).toFixed(2); }); return p; }
  function ball() { var p = C(12, 12, 9.6), v = []; for (var i = 0; i < 5; i++) { var a = -Math.PI / 2 + i * 2 * Math.PI / 5; v.push([12 + 3.6 * Math.cos(a), 12 + 3.6 * Math.sin(a), a]); } p += 'M' + v.map(function (q) { return q[0].toFixed(2) + ' ' + q[1].toFixed(2); }).join('L') + 'z'; v.forEach(function (q) { p += 'M' + q[0].toFixed(2) + ' ' + q[1].toFixed(2) + 'L' + (12 + 9.6 * Math.cos(q[2])).toFixed(2) + ' ' + (12 + 9.6 * Math.sin(q[2])).toFixed(2); }); return p; }
  function flower() { var p = ''; for (var i = 0; i < 5; i++) { var a = -Math.PI / 2 + i * 2 * Math.PI / 5; p += C(12 + 4.4 * Math.cos(a), 10.5 + 4.4 * Math.sin(a), 2.9); } return p + C(12, 10.5, 1.8) + 'M12 16.2V22.5M12 20c-1.6-1.6-3.6-1.9-4.8-1.3M12 20c1.6-1.6 3.6-1.9 4.8-1.3'; }
  var ICONS = {
    heart: 'M12 20.5s-7.5-4.6-9.2-9.3C1.6 7.8 3.9 4.5 7.3 4.5c2 0 3.6 1.1 4.7 2.8 1.1-1.7 2.7-2.8 4.7-2.8 3.4 0 5.7 3.3 4.5 6.7-1.7 4.7-9.2 9.3-9.2 9.3z',
    star: star(), sun: sun(),
    moon: 'M19.5 14.6A7.8 7.8 0 0 1 9.4 4.5a7.8 7.8 0 1 0 10.1 10.1z',
    cloud: 'M7 18.5h10.2a3.8 3.8 0 0 0 .6-7.6 5.6 5.6 0 0 0-10.9-1.3A4.5 4.5 0 0 0 7 18.5z',
    bolt: 'M13.5 2.5 5 13.5h6l-1 8 8.5-11h-6z',
    music: 'M9 18V5.5l10-2v12.5' + C(6.5, 18, 2.5) + C(16.5, 16, 2.5),
    waves: wave(),
    drop: 'M12 2.8S5.5 10.4 5.5 14.8a6.5 6.5 0 0 0 13 0C18.5 10.4 12 2.8 12 2.8z',
    flower: flower(),
    paw: C(12, 15.6, 3.6) + C(6.8, 10.2, 1.8) + C(10, 6.6, 1.8) + C(14, 6.6, 1.8) + C(17.2, 10.2, 1.8),
    smile: C(12, 12, 9.5) + C(9, 9.8, 0.6) + C(15, 9.8, 0.6) + 'M8 14a4.6 4.6 0 0 0 8 0',
    crown: 'M4 18.5h16M4.5 18.5 3 8l5 4 4-6.5 4 6.5 5-4-1.5 10.5',
    mountain: 'M2.5 19.5 9 8.5l4 6.5 2.5-3.5 6 8z',
    tree: 'M12 2.5 6 10.5h3.5L5 16.5h14l-4.5-6H18zM12 16.5v5',
    plane: 'M21.5 2.5 10.5 13.5M21.5 2.5l-7 19-4-8-8-4z',
    fish: 'M3 12c3-4.8 9-6.2 13.5-3.2L21 5.5v13l-4.5-3.3C12 18.2 6 16.8 3 12z' + C(8, 11, 0.7),
    anchor: C(12, 4.8, 2.3) + 'M12 7.1V21M8 11h8M4.5 14.5a7.5 7.5 0 0 0 15 0',
    rainbow: 'M3 18a9 9 0 0 1 18 0M5.5 18a6.5 6.5 0 0 1 13 0M8 18a4 4 0 0 1 8 0',
    ball: ball(),
    infinity: 'M12 12c-2-2.7-3.6-4-5.5-4a4 4 0 0 0 0 8c1.9 0 3.5-1.3 5.5-4s3.6-4 5.5-4a4 4 0 0 1 0 8c-1.9 0-3.5-1.3-5.5-4z',
    cat: 'M5 8.5 4.5 3.5 9 6.5h6l4.5-3-.5 5c1 1.4 1.5 3 1.5 4.7 0 4.3-3.8 7.3-8.5 7.3s-8.5-3-8.5-7.3c0-1.7.5-3.3 1.5-4.7z' + C(9.5, 12, 0.6) + C(14.5, 12, 0.6) + 'M12 14.6v1.2'
  };
  var ICON_NAMES = { heart: 'Heart', star: 'Star', sun: 'Sun', moon: 'Moon', cloud: 'Cloud', bolt: 'Lightning', music: 'Music', waves: 'Waves', drop: 'Moya drop', flower: 'Flower', paw: 'Paw', smile: 'Smiley', crown: 'Crown', mountain: 'Mountain', tree: 'Tree', plane: 'Paper plane', fish: 'Fish', anchor: 'Anchor', rainbow: 'Rainbow', ball: 'Football', infinity: 'Infinity', cat: 'Cat' };
  var EMOJI = ['😀', '😎', '🥰', '🦄', '🐶', '🐱', '🦖', '🐢', '🐬', '🌸', '🌈', '⭐', '⚽', '🏀', '🎾', '✈️', '🎵', '🍕', '🍦', '👑'];
  var paths = {};
  function icon(k) { return paths[k] || (paths[k] = new Path2D(ICONS[k])); }

  /* ---------- Fonts ---------- */
  function family(style) {
    if (style === 'Classic') return "'Bodoni Moda', Georgia, serif";
    if (style === 'Script') return "'Great Vibes', cursive";
    return getComputedStyle(D.body).fontFamily || 'sans-serif';
  }
  function fontsReady() {
    if (!D.fonts || !D.fonts.load) return Promise.resolve();
    return Promise.all(['500 40px "Bodoni Moda"', '40px "Great Vibes"'].map(function (f) { return D.fonts.load(f).catch(function () {}); }));
  }

  /* ---------- Image to engraving ---------- */
  function otsu(vals) {
    var hist = new Array(256).fill(0), n = vals.length; if (!n) return 128;
    for (var i = 0; i < n; i++) hist[vals[i]]++;
    var sum = 0; for (i = 0; i < 256; i++) sum += i * hist[i];
    var sB = 0, wB = 0, best = 0, t = 128;
    for (i = 0; i < 256; i++) { wB += hist[i]; if (!wB) continue; var wF = n - wB; if (!wF) break; sB += i * hist[i]; var mB = sB / wB, mF = (sum - sB) / wF, v = wB * wF * (mB - mF) * (mB - mF); if (v > best) { best = v; t = i; } }
    return t;
  }
  function processImage(src, o) {
    var max = o.mode === 'photo' ? 520 : 760;
    var sc = Math.min(1, max / Math.max(src.width, src.height));
    var w = Math.max(1, Math.round(src.width * sc)), h = Math.max(1, Math.round(src.height * sc));
    var c = canvas(w, h), x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(src, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h).data, N = w * h, L = new Uint8Array(N), bg = new Uint8Array(N), i;
    for (i = 0; i < N; i++) { L[i] = Math.round(0.299 * d[i * 4] + 0.587 * d[i * 4 + 1] + 0.114 * d[i * 4 + 2]); if (d[i * 4 + 3] < 100) bg[i] = 1; }
    if (o.bg) {
      // Remove the background: flood in from the edges through anything close to the edge colour
      var rs = [], gs = [], bs = [];
      function edge(p) { if (d[p * 4 + 3] >= 100) { rs.push(d[p * 4]); gs.push(d[p * 4 + 1]); bs.push(d[p * 4 + 2]); } }
      for (var xx = 0; xx < w; xx++) { edge(xx); edge((h - 1) * w + xx); }
      for (var yy = 0; yy < h; yy++) { edge(yy * w); edge(yy * w + w - 1); }
      if (rs.length) {
        var med = function (a) { a.sort(function (p, q) { return p - q; }); return a[a.length >> 1]; };
        var mr = med(rs), mg = med(gs), mb = med(bs), tol = 46 * 46;
        var near = function (p) { var dr = d[p * 4] - mr, dg = d[p * 4 + 1] - mg, db = d[p * 4 + 2] - mb; return dr * dr + dg * dg + db * db < tol; };
        var q = new Int32Array(N), qh = 0, qt = 0, seen = new Uint8Array(N);
        var push = function (p) { if (!seen[p] && (bg[p] || near(p))) { seen[p] = 1; bg[p] = 1; q[qt++] = p; } };
        for (xx = 0; xx < w; xx++) { push(xx); push((h - 1) * w + xx); }
        for (yy = 0; yy < h; yy++) { push(yy * w); push(yy * w + w - 1); }
        while (qh < qt) { var p = q[qh++], px = p % w; if (px > 0) push(p - 1); if (px < w - 1) push(p + 1); if (p >= w) push(p - w); if (p < N - w) push(p + w); }
      }
    }
    if (o.mode === 'outline') {
      var A = new Float32Array(N), ink0 = new Uint8Array(N);
      for (i = 0; i < N; i++) A[i] = bg[i] ? 255 : L[i];
      for (var yy2 = 1; yy2 < h - 1; yy2++) for (var xx2 = 1; xx2 < w - 1; xx2++) {
        var k2 = yy2 * w + xx2;
        var gx = A[k2 - w + 1] + 2 * A[k2 + 1] + A[k2 + w + 1] - A[k2 - w - 1] - 2 * A[k2 - 1] - A[k2 + w - 1];
        var gy = A[k2 + w - 1] + 2 * A[k2 + w] + A[k2 + w + 1] - A[k2 - w - 1] - 2 * A[k2 - w] - A[k2 - w + 1];
        if (Math.hypot(gx, gy) > 150 || (!bg[k2] && L[k2] < 70)) ink0[k2] = 1;
      }
      var inkO = new Uint8Array(N);
      for (i = 0; i < N; i++) if (ink0[i]) { var cx0 = i % w; inkO[i] = 1; if (cx0 > 0) inkO[i - 1] = 1; if (cx0 < w - 1) inkO[i + 1] = 1; if (i >= w) inkO[i - w] = 1; if (i < N - w) inkO[i + w] = 1; }
      return maskFrom(inkO, w, h);
    }
    var fg = []; for (i = 0; i < N; i++) if (!bg[i]) fg.push(L[i]);
    var ink = new Uint8Array(N), shift = (o.detail - 50) / 50;
    if (o.mode === 'photo') {
      var f = new Float32Array(N);
      for (i = 0; i < N; i++) f[i] = clamp((L[i] / 255 - 0.5) * 1.25 + 0.5 - shift * 0.3, 0, 1);
      for (var y = 0; y < h; y++) for (var x2 = 0; x2 < w; x2++) {
        var k = y * w + x2; if (bg[k]) continue;
        var old = f[k], nw = old < 0.5 ? 0 : 1, er = old - nw; ink[k] = nw === 0 ? 1 : 0;
        if (x2 + 1 < w) f[k + 1] += er * 7 / 16;
        if (y + 1 < h) { if (x2 > 0) f[k + w - 1] += er * 3 / 16; f[k + w] += er * 5 / 16; if (x2 + 1 < w) f[k + w + 1] += er / 16; }
      }
    } else {
      var t = clamp(otsu(fg) + shift * 70, 8, 247);
      for (i = 0; i < N; i++) if (!bg[i]) ink[i] = L[i] < t ? 1 : 0;
    }
    if (o.invert) for (i = 0; i < N; i++) if (!bg[i]) ink[i] = ink[i] ? 0 : 1;
    return maskFrom(ink, w, h);
  }
  function maskFrom(ink, w, h) {
    var N = w * h, i, y, x2;
    var x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (i = 0; i < N; i++) if (ink[i]) { var cx = i % w, cy = (i / w) | 0; if (cx < x0) x0 = cx; if (cx > x1) x1 = cx; if (cy < y0) y0 = cy; if (cy > y1) y1 = cy; }
    if (x1 < 0) return null;
    var mw = x1 - x0 + 1, mh = y1 - y0 + 1, m = canvas(mw, mh), mx = m.getContext('2d'), id = mx.createImageData(mw, mh);
    for (y = y0; y <= y1; y++) for (x2 = x0; x2 <= x1; x2++) if (ink[y * w + x2]) { var o4 = ((y - y0) * mw + (x2 - x0)) * 4; id.data[o4] = id.data[o4 + 1] = id.data[o4 + 2] = 255; id.data[o4 + 3] = 255; }
    mx.putImageData(id, 0, 0);
    return m;
  }
  function emojiMask(ch) {
    var c = canvas(240, 240), x = c.getContext('2d');
    x.textAlign = 'center'; x.textBaseline = 'middle'; x.font = '190px "Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",sans-serif';
    x.fillText(ch, 120, 128);
    return processImage(c, { mode: 'outline', detail: 50, invert: false, bg: true });
  }
  function strokesMask(strokes) {
    var c = canvas(800, 800), x = c.getContext('2d');
    drawStrokes(x, strokes, 800, 0, 0, 800 * 0.02, '#fff');
    return processImage(c, { mode: 'line', detail: 50, invert: true, bg: false }) || null;
  }

  /* ---------- Drawing the design ---------- */
  function drawStrokes(x, strokes, unit, ox, oy, base, color) {
    x.save(); x.lineCap = 'round'; x.lineJoin = 'round'; x.strokeStyle = color; x.fillStyle = color;
    strokes.forEach(function (s) {
      var lw = (s.w === 2 ? 2.2 : 1) * base, P = s.pts.map(function (p) { return [ox + p[0] * unit, oy + p[1] * unit]; });
      x.lineWidth = lw;
      if (P.length === 1) { x.beginPath(); x.arc(P[0][0], P[0][1], lw / 2, 0, 7); x.fill(); return; }
      x.beginPath(); x.moveTo(P[0][0], P[0][1]);
      for (var i = 1; i < P.length - 1; i++) x.quadraticCurveTo(P[i][0], P[i][1], (P[i][0] + P[i + 1][0]) / 2, (P[i][1] + P[i + 1][1]) / 2);
      x.lineTo(P[P.length - 1][0], P[P.length - 1][1]); x.stroke();
    });
    x.restore();
  }
  var measureCtx = canvas(4, 4).getContext('2d');
  function size(o) {
    if (o.type === 'text') {
      measureCtx.font = (o.style === 'Classic' ? '500 ' : o.style === 'Modern' ? '600 ' : '') + '100px ' + family(o.style);
      var t = o.style === 'Classic' ? o.text.toUpperCase() : o.text;
      var tw = measureCtx.measureText(t).width / 100 * (o.style === 'Classic' ? 1.12 : 1);
      return { w: Math.max(0.2, tw) * o.s, h: o.s };
    }
    if (o.type === 'img') return { w: o.s * o.mask.width / o.mask.height, h: o.s };
    return { w: o.s, h: o.s };
  }
  function drawObj(x, o, unit) {
    x.save(); x.translate(o.x * unit, o.y * unit); x.rotate(o.r * Math.PI / 180);
    if (o.type === 'text') {
      var t = o.style === 'Classic' ? o.text.toUpperCase() : o.text;
      x.font = (o.style === 'Classic' ? '500 ' : o.style === 'Modern' ? '600 ' : '') + (o.s * unit) + 'px ' + family(o.style);
      if (o.style === 'Classic' && 'letterSpacing' in x) x.letterSpacing = (o.s * unit * 0.12) + 'px';
      x.textAlign = 'center'; x.textBaseline = 'middle'; x.fillStyle = '#fff'; x.direction = 'inherit';
      x.fillText(t, 0, o.s * unit * 0.04);
    } else if (o.type === 'icon') {
      var k = o.s * unit / 24; x.scale(k, k); x.translate(-12, -12);
      x.lineCap = 'round'; x.lineJoin = 'round'; x.strokeStyle = '#fff'; x.lineWidth = o.bold ? 2.5 : 1.6; x.stroke(icon(o.key));
    } else if (o.type === 'img') {
      var s = size(o); x.imageSmoothingEnabled = o.kind !== 'upload' || o.opts.mode !== 'photo';
      x.drawImage(o.mask, -s.w * unit / 2, -s.h * unit / 2, s.w * unit, s.h * unit);
    }
    x.restore();
  }
  // White ink for the whole design, unit = pixels per artboard width, offset in pixels
  function renderInk(state, unit, w, h, ox, oy, clip, AR) {
    var c = canvas(w, h), x = c.getContext('2d');
    x.save(); x.translate(ox, oy);
    if (clip) { x.beginPath(); x.rect(0, 0, unit, AR * unit); x.clip(); }
    state.objs.forEach(function (o) { drawObj(x, o, unit); });
    drawStrokes(x, state.strokes, unit, 0, 0, unit * 0.016, '#fff');
    x.restore();
    return c;
  }
  function tint(ink, y, h, kind) {
    var c = canvas(ink.width, ink.height), x = c.getContext('2d');
    x.drawImage(ink, 0, 0); x.globalCompositeOperation = 'source-in';
    if (kind === 'black') x.fillStyle = '#000';
    else { var g = x.createLinearGradient(0, y, 0, y + h); g.addColorStop(0, '#FBFCFD'); g.addColorStop(0.55, '#BCC4CC'); g.addColorStop(1, '#8E98A3'); x.fillStyle = g; }
    x.fillRect(0, 0, c.width, c.height);
    return c;
  }

  /* ---------- Files for the order ---------- */
  function loadImg(url, cors) {
    return new Promise(function (res, rej) { if (!url) return rej(); var i = new Image(); if (cors) i.crossOrigin = 'anonymous'; i.onload = function () { res(i); }; i.onerror = rej; i.src = url; });
  }
  function blob(c, type, q) { return new Promise(function (res) { try { c.toBlob(function (b) { res(b); }, type, q); } catch (e) { res(null); } }); }
  function zoneRect(z, IW, IH) { return { x: (0.5 - z.w / 200) * IW, y: (z.top - z.h / 2) / 100 * IH, w: z.w / 100 * IW, h: z.h / 100 * IH }; }
  function ratio(z) { return (z.h * 2500) / (z.w * 2000); }
  function summary(state) {
    var bits = [];
    state.objs.forEach(function (o) {
      if (o.type === 'text') bits.push('Text "' + o.text + '" (' + o.style + ')');
      else if (o.type === 'icon') bits.push('Sticker: ' + (ICON_NAMES[o.key] || o.key));
      else if (o.kind === 'emoji') bits.push('Emoji ' + o.label);
      else if (o.kind === 'upload') bits.push('Uploaded image (' + (o.opts.mode === 'photo' ? 'photo' : 'line art') + ')');
      else bits.push('Drawing');
    });
    if (state.strokes.length) bits.push('Hand drawing');
    return bits.join(', ');
  }
  function isEmpty(state) { return !state.objs.length && !state.strokes.length; }
  function hasUpload(state) { return state.objs.some(function (o) { return o.kind === 'upload'; }); }
  function build(state, opts) {
    var AR = ratio(opts.zone), unit = 2400;
    return fontsReady().then(function () {
      var ink = renderInk(state, unit, unit, Math.round(unit * AR), 0, 0, true, AR);
      var file = tint(ink, 0, ink.height, 'black');
      var jobs = [blob(file, 'image/png')];
      jobs.push(loadImg(opts.back, true).catch(function () { return loadImg(opts.front, true); }).then(function (im) {
        var IW = im.naturalWidth, IH = im.naturalHeight, r = zoneRect(opts.zone, IW, IH), c = canvas(IW, IH), x = c.getContext('2d');
        x.fillStyle = '#EEF3F9'; x.fillRect(0, 0, IW, IH); x.drawImage(im, 0, 0);
        var small = renderInk(state, r.w, Math.ceil(r.w), Math.ceil(r.h), 0, 0, true, AR);
        x.shadowColor = 'rgba(0,0,0,0.35)'; x.shadowOffsetY = Math.max(1, IW / 1200);
        x.drawImage(tint(small, 0, r.h, 'silver'), r.x, r.y);
        return blob(c, 'image/jpeg', 0.88);
      }).catch(function () { return null; }));
      var up = state.objs.filter(function (o) { return o.kind === 'upload' && o.src; })[0];
      jobs.push(up ? blob(up.src, 'image/jpeg', 0.9) : Promise.resolve(null));
      return Promise.all(jobs).then(function (r) { return { design: r[0], preview: r[1], original: r[2], summary: summary(state), hasUpload: hasUpload(state) }; });
    });
  }
  // A silver overlay sized to the engraving area, for showing on top of a bottle image
  function overlay(state, zone, cssW) {
    var AR = ratio(zone), dpr = Math.min(W.devicePixelRatio || 1, 2), wpx = Math.max(40, cssW * dpr);
    var ink = renderInk(state, wpx, wpx, wpx * AR, 0, 0, true, AR);
    return tint(ink, 0, wpx * AR, 'silver');
  }

  /* ---------- Saving work between visits ---------- */
  function serialise(state) {
    return JSON.stringify({ strokes: state.strokes, rights: state.rights, objs: state.objs.map(function (o) {
      var c = {}; for (var k in o) if (k !== 'mask' && k !== 'src' && k !== 'alphaSrc') c[k] = o[k];
      if (o.mask) c.mask = o.mask.toDataURL('image/png');
      if (o.src) { try { var k = Math.min(1, 1400 / Math.max(o.src.width, o.src.height)), t = canvas(o.src.width * k, o.src.height * k); t.getContext('2d').drawImage(o.src, 0, 0, t.width, t.height); c.src = t.toDataURL('image/jpeg', 0.85); } catch (e) {} }
      return c;
    }) });
  }
  function restore(json) {
    try {
      var d = JSON.parse(json); if (!d || !d.objs) return Promise.resolve(null);
      return Promise.all(d.objs.map(function (o) {
        function toCanvas(u) { return loadImg(u).then(function (im) { var c = canvas(im.width, im.height); c.getContext('2d').drawImage(im, 0, 0); return c; }); }
        if (!o.mask) return Promise.resolve(o);
        return toCanvas(o.mask).then(function (m) {
          o.mask = m;
          if (typeof o.src !== 'string') { delete o.src; return o; }
          return toCanvas(o.src).then(function (c) { o.src = c; o.alphaSrc = c; return o; }, function () { delete o.src; return o; });
        });
      })).then(function (objs) { return { objs: objs, strokes: d.strokes || [], rights: !!d.rights }; }).catch(function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }
  function clone(state) { return { objs: state.objs.map(function (o) { var c = {}; for (var k in o) c[k] = (k === 'opts' ? Object.assign({}, o[k]) : o[k]); return c; }), strokes: state.strokes.map(function (s) { return { w: s.w, pts: s.pts.slice() }; }), rights: state.rights }; }
  // A single line of text, sized to sit nicely in the engraving area
  function textState(text, style, zone) {
    var AR = ratio(zone), o = { id: nid(), type: 'text', text: text, style: style || 'Classic', x: 0.5, y: AR / 2, r: 0, s: 1 };
    var w = size(o).w;
    o.s = Math.min(AR * 0.42, 0.86 / Math.max(0.01, w));
    return { objs: [o], strokes: [], rights: false };
  }
  function fromStrokes(strokes, zone) {
    var m = strokesMask(strokes), AR = ratio(zone);
    if (!m) return { objs: [], strokes: [], rights: false };
    var s = Math.min(AR * 0.8, 0.8 * m.height / m.width);
    return { objs: [{ id: nid(), type: 'img', kind: 'drawing', mask: m, x: 0.5, y: AR / 2, s: s, r: 0 }], strokes: [], rights: false };
  }

  /* ---------- The editor ---------- */
  var CSS = '\
.mst{position:fixed;inset:0;z-index:1000;display:flex;align-items:stretch;justify-content:center;background:rgba(18,21,58,.55);font-family:var(--font-body-family);color:var(--moya-navy,#1E2152)}\
.mst *{box-sizing:border-box}\
.mst__box{display:flex;flex-direction:column;width:min(118rem,100%);height:100%;background:#F4F7FB;overflow:hidden}\
@media(min-width:990px){.mst{padding:2.4rem}.mst__box{height:auto;max-height:100%;border-radius:2.4rem;box-shadow:0 3rem 8rem rgba(18,21,58,.4)}}\
.mst__head{display:flex;align-items:center;gap:1.2rem;padding:1.2rem 1.6rem;background:#fff;border-bottom:1px solid rgba(30,33,82,.08)}\
.mst__head h2{margin:0;flex:1;font-size:1.8rem;font-weight:600;color:inherit;letter-spacing:0}\
.mst__x{appearance:none;border:0;background:none;width:4rem;height:4rem;border-radius:50%;font-size:2.4rem;line-height:1;cursor:pointer;color:inherit}\
.mst__x:hover{background:#EEF3F9}\
.mst__done{appearance:none;border:0;border-radius:999px;padding:1.1rem 2.2rem;background:#1E2152;color:#fff;font:inherit;font-weight:700;font-size:1.5rem;cursor:pointer}\
.mst__body{flex:1;min-height:0;display:grid;overflow:auto}\
@media(min-width:990px){.mst__body{grid-template-columns:minmax(0,1.15fr) minmax(32rem,.85fr);overflow:hidden}.mst__left,.mst__right{overflow:auto}}\
.mst__left{padding:1.6rem;display:grid;gap:1.2rem;align-content:start;grid-auto-rows:max-content}\
.mst__boardwrap{min-height:min-content}\
.mst__right{padding:1.6rem;background:#fff;display:grid;gap:1.6rem;align-content:start}\
.mst__boardwrap{position:relative;border-radius:1.8rem;overflow:hidden;background:#dfe7f1;box-shadow:inset 0 0 0 1px rgba(30,33,82,.08)}\
@media(max-width:989px){.mst__body{display:flex;flex-direction:column;overflow:hidden}.mst__left{flex:none;padding:1rem 1.2rem .8rem;gap:.8rem;background:#F4F7FB;box-shadow:0 6px 12px -10px rgba(30,33,82,.35);z-index:2}.mst__right{flex:1;min-height:0;overflow:auto;padding:1.4rem 1.2rem 2.4rem}.mst__left .mst__hint[data-hint]{display:none}.mst__selbar{padding:.7rem .9rem;gap:.5rem .9rem;grid-template-columns:1fr 1fr}.mst__selbar .mst__row{flex-direction:column;align-items:stretch;gap:.1rem}.mst__selbar .mst__row label{min-width:0;font-size:1.15rem}.mst__selbar .mst__row input[type=range]{min-width:0}.mst__selbar .mst__tools{grid-column:1/-1;gap:.5rem}.mst__selbar .mst__tools .mst__btn{padding:.6rem 1.1rem;font-size:1.25rem}.mst__mini{grid-template-columns:auto 1fr;gap:.8rem}.mst__mini .mst__bottle{width:4.8rem}.mst__mini .mst__hint{display:none}.mst__foot .mst__btn{padding:.6rem 1.1rem;font-size:1.25rem}}\
.mst__ib,.mst__see,.mst__mfoot,.mst__short{display:none}\
.mst__tools .mst__btn svg{width:1.6rem;height:1.6rem;vertical-align:-.3rem;margin-right:.4rem}\
@media(max-width:989px){\
.mst .mst__head{padding:.6rem .8rem;gap:.4rem}.mst .mst__head h2{font-size:1.6rem}.mst .mst__long{display:none}.mst .mst__short{display:inline}.mst .mst__x{width:3.6rem;height:3.6rem}.mst .mst__done{padding:.9rem 1.8rem}\
.mst .mst__ib{display:grid;place-items:center;appearance:none;border:0;background:none;width:3.8rem;height:3.8rem;border-radius:50%;color:inherit;cursor:pointer}.mst .mst__ib:disabled{opacity:.3}.mst .mst__ib svg{width:2.2rem;height:2.2rem}\
.mst .mst__left{padding:.8rem 1rem .6rem;gap:.6rem}.mst .mst__mini{display:none}\
.mst .mst__see{display:inline-flex;align-items:center;gap:.4rem;position:absolute;right:.8rem;bottom:.8rem;appearance:none;border:0;border-radius:999px;padding:.6rem 1rem;background:rgba(255,255,255,.94);color:#1E2152;font:inherit;font-weight:700;font-size:1.2rem;box-shadow:0 .4rem 1.2rem -.6rem rgba(30,33,82,.6);cursor:pointer}.mst .mst__see svg{width:1.4rem;height:1.4rem}\
.mst .mst__selbar{grid-template-columns:minmax(0,1fr) minmax(0,1fr) auto;align-items:end;padding:.6rem .8rem;gap:.4rem 1.4rem}.mst .mst__selbar .mst__tools{grid-column:auto;flex-wrap:nowrap;gap:.3rem}.mst .mst__selbar .mst__tools .mst__btn{padding:.7rem;font-size:0;line-height:0}.mst .mst__selbar .mst__tools .mst__btn svg{width:1.8rem;height:1.8rem;margin:0}\
.mst .mst__right{padding-top:0}.mst .mst__tabs{position:sticky;top:0;z-index:2;margin:0 -1.2rem;border-radius:0;padding:.8rem 1.2rem;background:#fff;box-shadow:0 1px 0 rgba(30,33,82,.08)}.mst .mst__tabs button{background:#EEF3F9}.mst .mst__tabs button[aria-selected=true]{background:#1E2152}\
.mst .mst__mfoot{display:flex;justify-content:center;padding-top:.8rem}\
}\
.mst__board{display:block;width:100%;touch-action:none;cursor:default}\
.mst__board.is-draw{cursor:crosshair}\
.mst__hint{margin:0;font-size:1.3rem;line-height:1.45;color:#5B6488}\
.mst__selbar{display:grid;gap:1rem;padding:1.2rem 1.4rem;border-radius:1.4rem;background:#fff;box-shadow:0 0 0 1px rgba(30,33,82,.08)}\
.mst__selbar[hidden]{display:none}\
.mst__row{display:flex;align-items:center;gap:1rem;flex-wrap:wrap}\
.mst__row label{min-width:6.4rem;font-size:1.3rem;font-weight:600}\
.mst__row input[type=range]{flex:1;min-width:12rem;accent-color:#1E2152}\
.mst__btn{appearance:none;border:1px solid rgba(30,33,82,.2);background:#fff;color:#1E2152;border-radius:999px;padding:.8rem 1.4rem;font:inherit;font-weight:600;font-size:1.35rem;cursor:pointer}\
.mst__btn:hover{border-color:#1E2152}\
.mst__btn[aria-pressed=true]{background:#1E2152;color:#fff;border-color:#1E2152}\
.mst__btn:disabled{opacity:.4;cursor:default}\
.mst__btn--warn{color:#9b2c2c}\
.mst__tools{display:flex;gap:.8rem;flex-wrap:wrap}\
.mst__mini{display:grid;grid-template-columns:auto 1fr;gap:1.2rem;align-items:center}\
.mst__bottle{position:relative;width:9.6rem;aspect-ratio:4/5;border-radius:1.2rem;overflow:hidden;background:radial-gradient(90% 70% at 50% 40%,#fff,#DCE6F1);cursor:zoom-in;border:0;padding:0}\
.mst__bottle img,.mst__bottle canvas{position:absolute;pointer-events:none}\
.mst__bottle img{inset:0;width:100%;height:100%;object-fit:contain}\
.mst__big{position:fixed;inset:0;z-index:1001;display:flex;align-items:center;justify-content:center;background:rgba(18,21,58,.8);padding:2rem;cursor:zoom-out}\
.mst__big[hidden]{display:none}\
.mst__bigin{position:relative;height:min(90vh,120vw);aspect-ratio:4/5;border-radius:2rem;overflow:hidden;background:radial-gradient(90% 70% at 50% 40%,#fff,#DCE6F1);transition:transform .35s ease}\
.mst__bigin img,.mst__bigin canvas{position:absolute;pointer-events:none}\
.mst__bigin img{inset:0;width:100%;height:100%;object-fit:contain}\
.mst__bigbar{position:fixed;left:50%;bottom:2.4rem;translate:-50% 0;display:flex;gap:.8rem;z-index:1002}\
.mst__tabs{display:grid;grid-template-columns:repeat(4,1fr);gap:.4rem;padding:.4rem;border-radius:999px;background:#EEF3F9}\
.mst__tabs button{appearance:none;border:0;background:none;padding:1rem .4rem;border-radius:999px;font:inherit;font-weight:700;font-size:1.35rem;color:#1E2152;cursor:pointer}\
.mst__tabs button[aria-selected=true]{background:#1E2152;color:#fff}\
.mst__pane{display:grid;gap:1.2rem}\
.mst__pane[hidden]{display:none}\
.mst__pane h3{margin:0;font-size:1.6rem;font-weight:700;color:inherit;letter-spacing:0}\
.mst__pane p{margin:0;font-size:1.35rem;line-height:1.5;color:#5B6488}\
.mst__input{width:100%;padding:1.3rem 1.6rem;border:1px solid rgba(30,33,82,.22);border-radius:1.4rem;font:inherit;font-size:1.7rem;color:#1E2152;background:#fff}\
.mst__styles{display:grid;grid-template-columns:repeat(3,1fr);gap:.8rem}\
.mst__styles button{appearance:none;border:1px solid rgba(30,33,82,.2);border-radius:1.2rem;background:#fff;padding:.8rem .4rem;cursor:pointer;color:#1E2152;font:inherit;font-size:1.2rem}\
.mst__styles button b{display:block;font-weight:400;font-size:2.2rem;line-height:1.2}\
.mst__styles button[aria-pressed=true]{border-color:#1E2152;box-shadow:inset 0 0 0 1px #1E2152}\
.mst__grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(5.2rem,1fr));gap:.6rem}\
.mst__grid button{appearance:none;aspect-ratio:1;border:1px solid rgba(30,33,82,.14);border-radius:1.2rem;background:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#1E2152;font-size:2.6rem;line-height:1;padding:0}\
.mst__grid button:hover{border-color:#1E2152;background:#F4F7FB}\
.mst__grid svg{width:58%;height:58%}\
.mst__note{padding:1.2rem 1.4rem;border-radius:1.2rem;background:#FFF6E5;color:#6B4A00;font-size:1.3rem;line-height:1.5}\
.mst__note strong{display:block;margin-bottom:.2rem}\
.mst__drop{display:grid;place-items:center;gap:.6rem;padding:2.4rem 1.6rem;border:2px dashed rgba(30,33,82,.25);border-radius:1.6rem;text-align:center;cursor:pointer;background:#F8FAFD}\
.mst__drop:hover,.mst__drop.is-over{border-color:#1E2152;background:#EEF3F9}\
.mst__drop b{font-size:1.5rem}\
.mst__drop span{font-size:1.25rem;color:#5B6488}\
.mst__check{display:flex;gap:1rem;align-items:flex-start;font-size:1.35rem;line-height:1.45;cursor:pointer}\
.mst__check input{width:2rem;height:2rem;margin:.1rem 0 0;flex:none;accent-color:#1E2152}\
.mst__msg{margin:0;padding:1rem 1.2rem;border-radius:1rem;background:#FDECEC;color:#9b2c2c;font-size:1.35rem}\
.mst__msg:empty{display:none}\
.mst__msg.mst__ok{color:#1E7A55;background:#E8F6EF}\
.mst__seg{display:grid;grid-template-columns:1fr 1fr;gap:.4rem;padding:.4rem;border-radius:1.2rem;background:#EEF3F9}\
.mst__seg button{appearance:none;border:0;background:none;padding:.8rem;border-radius:.9rem;font:inherit;font-weight:600;font-size:1.3rem;color:#1E2152;cursor:pointer}\
.mst__seg button[aria-pressed=true]{background:#fff;box-shadow:0 1px 3px rgba(30,33,82,.15)}\
.mst__busy{position:absolute;inset:0;display:grid;place-items:center;background:rgba(255,255,255,.7);font-weight:700;font-size:1.5rem}\
.mst__busy[hidden]{display:none}\
.mst__foot{display:flex;gap:.8rem;flex-wrap:wrap;align-items:center}\
.mst__foot .mst__spacer{flex:1}\
.mst [hidden]{display:none!important}\
';
  var styleAdded = false;
  function open(opts) {
    if (!styleAdded) { var st = el('style'); st.textContent = CSS; D.head.appendChild(st); styleAdded = true; }
    var zone = opts.zone, AR = ratio(zone);
    var state = opts.state ? clone(opts.state) : { objs: [], strokes: [], rights: false };
    var hist = [clone(state)], hi = 0, sel = null, tool = 'text', pen = 1, boldIcons = false, dirty = false;
    var textStyle = 'Modern';
    var back = new Image(); back.crossOrigin = 'anonymous';
    var backOK = false;

    var root = el('div', { class: 'mst', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Design your engraving' });
    var stickerBtns = Object.keys(ICONS).map(function (k) { return '<button type="button" data-icon="' + k + '" title="' + ICON_NAMES[k] + '" aria-label="' + ICON_NAMES[k] + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="' + ICONS[k] + '"/></svg></button>'; }).join('');
    var emojiBtns = EMOJI.map(function (e) { return '<button type="button" data-emoji="' + e + '" aria-label="Emoji ' + e + '">' + e + '</button>'; }).join('');
    root.innerHTML = '\
<div class="mst__box">\
  <div class="mst__head"><button type="button" class="mst__x" data-close aria-label="Close">&times;</button><h2><span class="mst__long">Design your engraving</span><span class="mst__short">Your design</span></h2><button type="button" class="mst__ib" data-hundo aria-label="Undo"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/></svg></button><button type="button" class="mst__ib" data-hredo aria-label="Redo"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 14 5-5-5-5"/><path d="M20 9H9.5a5.5 5.5 0 0 0 0 11H13"/></svg></button><button type="button" class="mst__done" data-done>Done</button></div>\
  <div class="mst__body">\
    <div class="mst__left">\
      <div class="mst__boardwrap"><canvas class="mst__board" data-board aria-label="Your engraving. Tap something to select it, then drag to move it."></canvas><div class="mst__busy" data-busy hidden>Getting your image ready&hellip;</div><button type="button" class="mst__see" data-see><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 2h4v3l1.5 2v14a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V7L10 5Z"/></svg>See on bottle</button></div>\
      <p class="mst__hint" data-hint>This is the engraving area, zoomed in. Tap anything to select it, drag to move, and use the round handle or the sliders to resize. Anything outside the dashed line won\'t be engraved.</p>\
      <div class="mst__selbar" data-selbar hidden>\
        <div class="mst__row"><label for="mstSize">Size</label><input id="mstSize" type="range" min="4" max="160" step="1" data-size></div>\
        <div class="mst__row"><label for="mstRot">Rotate</label><input id="mstRot" type="range" min="-180" max="180" step="1" data-rot></div>\
        <div class="mst__tools"><button type="button" class="mst__btn" data-center aria-label="Centre it"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="3"/><path d="M12 2v5M12 17v5M2 12h5M17 12h5"/></svg>Centre it</button><button type="button" class="mst__btn" data-front aria-label="Bring to front"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><rect x="8" y="8" width="12" height="12" rx="2" fill="currentColor" fill-opacity=".2"/><path d="M16 4H6a2 2 0 0 0-2 2v10"/></svg>Bring to front</button><button type="button" class="mst__btn mst__btn--warn" data-del aria-label="Delete"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>Delete</button></div>\
      </div>\
      <div class="mst__mini">\
        <button type="button" class="mst__bottle" data-mini aria-label="See it on your bottle, larger"><img data-mini-img alt=""><canvas data-mini-ink></canvas></button>\
        <div><p class="mst__hint" style="margin:0 0 .8rem" data-where></p>\
        <div class="mst__foot"><button type="button" class="mst__btn" data-undo>Undo</button><button type="button" class="mst__btn" data-redo>Redo</button><button type="button" class="mst__btn mst__btn--warn" data-clear>Start again</button></div></div>\
      </div>\
    </div>\
    <div class="mst__right">\
      <div class="mst__tabs" role="tablist">\
        <button type="button" role="tab" data-tab="text" aria-selected="true">Text</button>\
        <button type="button" role="tab" data-tab="draw" aria-selected="false">Draw</button>\
        <button type="button" role="tab" data-tab="stickers" aria-selected="false">Stickers</button>\
        <button type="button" role="tab" data-tab="upload" aria-selected="false">Upload</button>\
      </div>\
      <div class="mst__pane" data-pane="text">\
        <h3>Add words</h3><p>A name, a date or a short message, in any language.</p>\
        <input class="mst__input" type="text" maxlength="30" dir="auto" placeholder="Type here" data-text>\
        <div class="mst__styles"><button type="button" data-style="Classic" aria-pressed="false"><b style="font-family:\'Bodoni Moda\',Georgia,serif">Aa</b>Classic</button><button type="button" data-style="Modern" aria-pressed="true"><b style="font-weight:600">Aa</b>Modern</button><button type="button" data-style="Script" aria-pressed="false"><b style="font-family:\'Great Vibes\',cursive;font-size:2.8rem">Aa</b>Script</button></div>\
        <div class="mst__tools"><button type="button" class="mst__btn" data-addtext aria-pressed="true">Add as new text</button></div>\
        <p data-texthint>Tip: tap text on the design to change it.</p>\
      </div>\
      <div class="mst__pane" data-pane="draw" hidden>\
        <h3>Draw it yourself</h3><p>Draw straight onto the engraving area with your finger or mouse. Simple lines engrave best.</p>\
        <div class="mst__tools"><button type="button" class="mst__btn" data-pen="1" aria-pressed="true">Thin pen</button><button type="button" class="mst__btn" data-pen="2" aria-pressed="false">Thick pen</button></div>\
        <p>Use Undo to take back the last line.</p>\
      </div>\
      <div class="mst__pane" data-pane="stickers" hidden>\
        <h3>Stickers</h3><p>Clean line drawings, made to engrave well. Tap one to add it.</p>\
        <div class="mst__grid" data-icons>' + stickerBtns + '</div>\
        <div class="mst__tools"><button type="button" class="mst__btn" data-bold aria-pressed="false">Bolder lines</button></div>\
        <h3 style="margin-top:.8rem">Emoji</h3><p>Emoji become a single-colour engraving, so you\'ll see how each one will really look once it\'s added.</p>\
        <div class="mst__grid" data-emojis>' + emojiBtns + '</div>\
      </div>\
      <div class="mst__pane" data-pane="upload" hidden>\
        <h3>Your photo or logo</h3>\
        <div class="mst__note"><strong>Only upload images you have the right to use.</strong>That means your own photos, drawings or logos, or ones you have permission to use. We can\'t engrave copyrighted characters, brands, logos or artwork that aren\'t yours, and we\'ll get in touch if we can\'t engrave your image.</div>\
        <label class="mst__drop" data-drop><input type="file" accept="image/*" hidden data-file><b>Choose an image</b><span>JPG, PNG or WEBP, up to 15MB. Simple, high-contrast images work best.</span></label>\
        <p class="mst__msg" data-upmsg></p>\
        <div data-upctl hidden style="display:grid;gap:1rem">\
          <p>We\'ve turned your image into what our laser can engrave. Adjust it until you\'re happy.</p>\
          <div class="mst__seg"><button type="button" data-mode="line" aria-pressed="true">Line art</button><button type="button" data-mode="photo" aria-pressed="false">Photo</button></div>\
          <div class="mst__row"><label for="mstDetail">Detail</label><input id="mstDetail" type="range" min="0" max="100" value="50" data-detail></div>\
          <label class="mst__check"><input type="checkbox" checked data-bg> Remove the background</label>\
          <label class="mst__check"><input type="checkbox" data-inv> Swap engraved and plain areas</label>\
        </div>\
        <label class="mst__check"><input type="checkbox" data-rights> I own this image or have permission to use it, and it doesn\'t include anyone else\'s brand, logo or character.</label>\
      </div>\
      <p class="mst__msg" data-msg></p>\
      <div class="mst__mfoot"><button type="button" class="mst__btn mst__btn--warn" data-clear2>Start again</button></div>\
    </div>\
  </div>\
</div>\
<div class="mst__big" data-big hidden><div class="mst__bigin" data-bigin><img data-big-img alt="Your design on the back of your bottle"><canvas data-big-ink></canvas></div><div class="mst__bigbar"><button type="button" class="mst__btn" data-zoom>Zoom in</button><button type="button" class="mst__btn" data-bigclose>Close</button></div></div>';
    D.body.appendChild(root);
    var prevOverflow = D.documentElement.style.overflow; D.documentElement.style.overflow = 'hidden';
    function q(s) { return root.querySelector(s); }
    function qa(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
    var board = q('[data-board]'), bctx = board.getContext('2d'), msg = q('[data-msg]');
    var miniImg = q('[data-mini-img]'), miniInk = q('[data-mini-ink]'), bigImg = q('[data-big-img]'), bigInk = q('[data-big-ink]');
    var rights = q('[data-rights]'); rights.checked = !!state.rights;
    var hasPic = !!(opts.back || opts.front);
    q('[data-where]').innerHTML = '<strong>On your ' + (opts.item || 'bottle') + '.</strong> ' + (opts.where || 'We engrave on the back, in the space below the label.') + (opts.area ? ' The area is ' + opts.area + '.' : '') + (hasPic ? ' Tap the ' + (opts.item || 'bottle') + ' to see it bigger.' : '');
    if (!hasPic) { q('[data-mini]').hidden = true; q('[data-see]').hidden = true; }

    // View: the engraving area plus a margin around it
    var VW = 1 + MARGIN * 2, VH = AR + MARGIN * 2, cw = 0, ppu = 1, dpr = 1;
    function sizeBoard() {
      var r = board.parentNode.getBoundingClientRect(); cw = r.width;
      var maxH = W.innerWidth < 990 ? W.innerHeight * 0.36 : Math.min(W.innerHeight * 0.5, 520);
      var h = cw * VH / VW; if (h > maxH) { h = maxH; }
      board.style.height = h + 'px'; board.style.width = '100%';
      dpr = Math.min(W.devicePixelRatio || 1, 2);
      board.width = cw * dpr; board.height = h * dpr;
      ppu = Math.min(cw / VW, h / VH);
      draw();
    }
    function offX() { return (board.width / dpr - VW * ppu) / 2 + MARGIN * ppu; }
    function offY() { return (board.height / dpr - VH * ppu) / 2 + MARGIN * ppu; }
    function toUnits(e) { var r = board.getBoundingClientRect(); return [(e.clientX - r.left - offX()) / ppu, (e.clientY - r.top - offY()) / ppu]; }

    function draw() {
      if (!board.width) return;
      var x = bctx; x.setTransform(dpr, 0, 0, dpr, 0, 0); x.clearRect(0, 0, board.width, board.height);
      var ox = offX(), oy = offY();
      // the bottle surface behind the engraving area
      if (backOK) {
        var IW = back.naturalWidth, IH = back.naturalHeight, zr = zoneRect(zone, IW, IH), k = zr.w / 1;
        var sx = zr.x - MARGIN * k, sy = zr.y - MARGIN * k;
        x.drawImage(back, sx, sy, VW * k, VH * k, ox - MARGIN * ppu, oy - MARGIN * ppu, VW * ppu, VH * ppu);
      } else { x.fillStyle = '#3B4466'; x.fillRect(ox - MARGIN * ppu, oy - MARGIN * ppu, VW * ppu, VH * ppu); }
      // the design: outside parts faded, inside parts in silver
      var w = board.width / dpr, h = board.height / dpr;
      var full = renderInk(state, ppu, w, h, ox, oy, false, AR);
      x.globalAlpha = 0.28; x.drawImage(tint(full, oy, AR * ppu, 'silver'), 0, 0); x.globalAlpha = 1;
      var inside = renderInk(state, ppu, w, h, ox, oy, true, AR);
      x.save(); x.shadowColor = 'rgba(0,0,0,0.45)'; x.shadowOffsetY = 1; x.drawImage(tint(inside, oy, AR * ppu, 'silver'), 0, 0); x.restore();
      // the engraving area
      x.save(); x.setLineDash([6, 5]); x.lineWidth = 1.5; x.strokeStyle = 'rgba(255,255,255,0.85)'; x.strokeRect(ox, oy, ppu, AR * ppu);
      x.setLineDash([]); x.fillStyle = 'rgba(255,255,255,0.9)'; x.font = '600 11px ' + family('Modern'); x.textBaseline = 'bottom'; x.fillText('Engraving area', ox, oy - 4); x.restore();
      if (isEmpty(state)) { x.save(); x.fillStyle = 'rgba(255,255,255,0.85)'; x.font = '500 14px ' + family('Modern'); x.textAlign = 'center'; x.textBaseline = 'middle'; x.fillText(tool === 'draw' ? 'Draw here' : 'Add text, a drawing, a sticker or a photo', ox + ppu / 2, oy + AR * ppu / 2); x.restore(); }
      // selection
      var o = selObj();
      if (o && tool !== 'draw') {
        var s = size(o);
        x.save(); x.translate(ox + o.x * ppu, oy + o.y * ppu); x.rotate(o.r * Math.PI / 180);
        var hw = s.w * ppu / 2 + 6, hh = s.h * ppu / 2 + 6;
        x.setLineDash([5, 4]); x.lineWidth = 1.5; x.strokeStyle = '#A9C5E1'; x.strokeRect(-hw, -hh, hw * 2, hh * 2); x.setLineDash([]);
        x.fillStyle = '#fff'; x.strokeStyle = '#1E2152'; x.lineWidth = 2;
        x.beginPath(); x.arc(hw, hh, 11, 0, 7); x.fill(); x.stroke();
        x.beginPath(); x.moveTo(hw - 4, hh + 3); x.lineTo(hw + 3, hh - 4); x.moveTo(hw - 1, hh + 4); x.lineTo(hw + 4, hh + 4); x.lineTo(hw + 4, hh - 1); x.stroke();
        x.fillStyle = '#9b2c2c'; x.beginPath(); x.arc(hw, -hh, 11, 0, 7); x.fill();
        x.strokeStyle = '#fff'; x.beginPath(); x.moveTo(hw - 4, -hh - 4); x.lineTo(hw + 4, -hh + 4); x.moveTo(hw + 4, -hh - 4); x.lineTo(hw - 4, -hh + 4); x.stroke();
        x.restore();
      }
      board.classList.toggle('is-draw', tool === 'draw');
      drawMini();
      syncSel();
    }
    var miniT = 0;
    function drawMini() {
      clearTimeout(miniT);
      miniT = setTimeout(function () {
        [[miniImg, miniInk], [bigImg, bigInk]].forEach(function (pair) {
          var im = pair[0], c = pair[1], box = im.getBoundingClientRect(); if (!box.width) return;
          var r = zoneRect(zone, box.width, box.height);
          c.style.left = r.x + 'px'; c.style.top = r.y + 'px'; c.style.width = r.w + 'px'; c.style.height = r.h + 'px';
          var ov = overlay(state, zone, r.w); c.width = ov.width; c.height = ov.height; c.getContext('2d').drawImage(ov, 0, 0);
          c.style.filter = 'drop-shadow(0 1px 0 rgba(0,0,0,.4))';
        });
      }, 60);
    }
    function selObj() { for (var i = 0; i < state.objs.length; i++) if (state.objs[i].id === sel) return state.objs[i]; return null; }
    function syncSel() {
      var o = selObj(), bar = q('[data-selbar]');
      bar.hidden = !o || tool === 'draw';
      if (o) { q('[data-size]').value = Math.round(o.s / AR * 100); q('[data-rot]').value = Math.round(o.r); }
      var isText = o && o.type === 'text';
      q('[data-addtext]').textContent = isText ? 'Add as new text' : 'Add text';
      if (isText && D.activeElement !== q('[data-text]')) { q('[data-text]').value = o.text; }
      if (isText) qa('[data-style]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.style === o.style ? 'true' : 'false'); });
      var up = o && o.kind === 'upload', upc = q('[data-upctl]');
      var target = up ? o : state.objs.filter(function (x) { return x.kind === 'upload'; })[0];
      upc.hidden = !target || !target.src;
      if (target && target.opts) { qa('[data-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.mode === target.opts.mode ? 'true' : 'false'); }); q('[data-detail]').value = target.opts.detail; q('[data-bg]').checked = target.opts.bg; q('[data-inv]').checked = target.opts.invert; }
      q('[data-undo]').disabled = q('[data-hundo]').disabled = hi <= 0; q('[data-redo]').disabled = q('[data-hredo]').disabled = hi >= hist.length - 1;
    }
    function commit() { hist = hist.slice(0, hi + 1); hist.push(clone(state)); if (hist.length > 60) hist.shift(); hi = hist.length - 1; dirty = true; msg.textContent = ''; draw(); }
    function freeSpot(o) {
      var s = size(o), best = null, bestScore = 1e9;
      for (var gy = 0; gy < 3; gy++) for (var gx = 0; gx < 3; gx++) {
        var cx = 0.5 + (gx - 1) * Math.max(0, (1 - s.w) / 2), cy = AR / 2 + (gy - 1) * Math.max(0, (AR - s.h) / 2), score = Math.abs(gx - 1) * 0.02 + Math.abs(gy - 1) * 0.02;
        state.objs.forEach(function (p) { var t = size(p), ox = Math.max(0, Math.min(cx + s.w / 2, p.x + t.w / 2) - Math.max(cx - s.w / 2, p.x - t.w / 2)), oy = Math.max(0, Math.min(cy + s.h / 2, p.y + t.h / 2) - Math.max(cy - s.h / 2, p.y - t.h / 2)); score += ox * oy * 10; });
        if (score < bestScore) { bestScore = score; best = [cx, cy]; }
      }
      return best;
    }
    function add(o) {
      o.id = nid(); o.r = o.r || 0;
      if (o.x == null || o.auto) { if (state.objs.length) { var f = freeSpot(o); o.x = f[0]; o.y = f[1]; } else { o.x = 0.5; o.y = AR / 2; } delete o.auto; }
      state.objs.push(o); sel = o.id; commit();
    }

    // Board interaction: select, move, resize (handle or pinch), delete handle, or draw
    var ptrs = {}, drag = null, cur = null;
    function hit(p) {
      for (var i = state.objs.length - 1; i >= 0; i--) {
        var o = state.objs[i], s = size(o), a = -o.r * Math.PI / 180, dx = p[0] - o.x, dy = p[1] - o.y;
        var lx = dx * Math.cos(a) - dy * Math.sin(a), ly = dx * Math.sin(a) + dy * Math.cos(a), tol = 10 / ppu;
        if (Math.abs(lx) <= s.w / 2 + tol && Math.abs(ly) <= s.h / 2 + tol) return o;
      }
      return null;
    }
    function handleAt(p, o) {
      var s = size(o), a = o.r * Math.PI / 180, pad = 6 / ppu, hw = s.w / 2 + pad, hh = s.h / 2 + pad;
      function at(x, y) { return [o.x + x * Math.cos(a) - y * Math.sin(a), o.y + x * Math.sin(a) + y * Math.cos(a)]; }
      var rz = at(hw, hh), dl = at(hw, -hh), R = 16 / ppu;
      if (Math.hypot(p[0] - rz[0], p[1] - rz[1]) < R) return 'resize';
      if (Math.hypot(p[0] - dl[0], p[1] - dl[1]) < R) return 'delete';
      return null;
    }
    board.addEventListener('pointerdown', function (e) {
      e.preventDefault(); board.setPointerCapture(e.pointerId);
      var p = toUnits(e); ptrs[e.pointerId] = p;
      var ids = Object.keys(ptrs);
      if (ids.length === 2 && selObj()) { var a = ptrs[ids[0]], b = ptrs[ids[1]], o = selObj(); cur = null; drag = { pinch: true, d0: Math.hypot(a[0] - b[0], a[1] - b[1]), a0: Math.atan2(b[1] - a[1], b[0] - a[0]), s0: o.s, r0: o.r }; return; }
      if (tool === 'draw') { cur = { w: pen, pts: [p] }; state.strokes.push(cur); draw(); return; }
      var o2 = selObj(), h = o2 && handleAt(p, o2);
      if (h === 'delete') { state.objs = state.objs.filter(function (x) { return x !== o2; }); sel = null; commit(); return; }
      if (h === 'resize') { drag = { resize: true, o: o2, d0: Math.hypot(p[0] - o2.x, p[1] - o2.y), s0: o2.s }; return; }
      var t = hit(p); sel = t ? t.id : null;
      if (t) { drag = { o: t, dx: p[0] - t.x, dy: p[1] - t.y, moved: false }; if (t.type === 'text') setTab('text'); }
      draw();
    });
    board.addEventListener('pointermove', function (e) {
      if (!ptrs[e.pointerId]) return;
      var p = toUnits(e); ptrs[e.pointerId] = p;
      if (cur) { var l = cur.pts[cur.pts.length - 1]; if (Math.hypot(p[0] - l[0], p[1] - l[1]) > 0.004) { cur.pts.push(p); draw(); } return; }
      if (!drag) return;
      var o = selObj(); if (!o) return;
      if (drag.pinch) { var ids = Object.keys(ptrs); if (ids.length < 2) return; var a = ptrs[ids[0]], b = ptrs[ids[1]]; o.s = clamp(drag.s0 * Math.hypot(a[0] - b[0], a[1] - b[1]) / drag.d0, 0.03, AR * 1.6); o.r = drag.r0 + (Math.atan2(b[1] - a[1], b[0] - a[0]) - drag.a0) * 180 / Math.PI; }
      else if (drag.resize) { o.s = clamp(drag.s0 * Math.hypot(p[0] - o.x, p[1] - o.y) / Math.max(0.001, drag.d0), 0.03, AR * 1.6); }
      else { o.x = clamp(p[0] - drag.dx, -0.2, 1.2); o.y = clamp(p[1] - drag.dy, -0.2, AR + 0.2); drag.moved = true; }
      draw();
    });
    function up(e) {
      delete ptrs[e.pointerId];
      if (cur) { cur = null; commit(); return; }
      if (drag && (drag.pinch || drag.resize || drag.moved)) commit();
      if (!Object.keys(ptrs).length) drag = null;
    }
    board.addEventListener('pointerup', up); board.addEventListener('pointercancel', up);

    // Tabs
    function setTab(t) {
      tool = t;
      qa('[data-tab]').forEach(function (b) { b.setAttribute('aria-selected', b.dataset.tab === t ? 'true' : 'false'); });
      qa('[data-pane]').forEach(function (p) { p.hidden = p.dataset.pane !== t; });
      q('[data-hint]').textContent = t === 'draw' ? 'Draw inside the dashed line. Switch to another tab to move or resize things.' : 'This is the engraving area, zoomed in. Tap anything to select it, drag to move, and use the round handle or the sliders to resize. Anything outside the dashed line won\'t be engraved.';
      draw();
    }
    qa('[data-tab]').forEach(function (b) { b.addEventListener('click', function () { setTab(b.dataset.tab); }); });

    // Text
    var textIn = q('[data-text]');
    textIn.addEventListener('input', function () {
      var o = selObj(), v = textIn.value;
      if (o && o.type === 'text') { if (v.trim()) { o.text = v; draw(); } return; }
      if (!v.trim()) return;
      add({ type: 'text', text: v, style: textStyle, s: Math.min(AR * 0.32, 0.22), auto: true });
    });
    textIn.addEventListener('change', function () { var o = selObj(); if (o && o.type === 'text') commit(); });
    q('[data-addtext]').addEventListener('click', function () {
      var v = textIn.value.trim() || 'Your text';
      sel = null; add({ type: 'text', text: v, style: textStyle, s: Math.min(AR * 0.32, 0.22), auto: true });
      textIn.value = v; textIn.focus(); textIn.select();
    });
    qa('[data-style]').forEach(function (b) {
      b.addEventListener('click', function () {
        textStyle = b.dataset.style;
        qa('[data-style]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var o = selObj(); if (o && o.type === 'text') { o.style = textStyle; commit(); }
      });
    });

    // Draw
    qa('[data-pen]').forEach(function (b) { b.addEventListener('click', function () { pen = +b.dataset.pen; qa('[data-pen]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); }); });

    // Stickers and emoji
    q('[data-icons]').addEventListener('click', function (e) { var b = e.target.closest('[data-icon]'); if (!b) return; add({ type: 'icon', key: b.dataset.icon, bold: boldIcons, s: Math.min(AR * 0.4, 0.3), auto: true }); });
    q('[data-bold]').addEventListener('click', function () {
      boldIcons = !boldIcons; this.setAttribute('aria-pressed', boldIcons ? 'true' : 'false');
      var o = selObj(); if (o && o.type === 'icon') { o.bold = boldIcons; commit(); }
    });
    q('[data-emojis]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-emoji]'); if (!b) return;
      var m = emojiMask(b.dataset.emoji);
      if (!m) { msg.textContent = 'That emoji doesn\'t engrave well on this device. Try another.'; return; }
      add({ type: 'img', kind: 'emoji', label: b.dataset.emoji, mask: m, s: Math.min(AR * 0.4, 0.3), auto: true });
    });

    // Upload
    var fileIn = q('[data-file]'), drop = q('[data-drop]'), upmsg = q('[data-upmsg]'), busy = q('[data-busy]');
    function useFile(f) {
      upmsg.textContent = ''; upmsg.classList.remove('mst__ok');
      if (!f) return;
      if (!/^image\//.test(f.type) && !/\.(jpe?g|png|webp|gif|heic)$/i.test(f.name)) { upmsg.textContent = 'Please choose an image file, such as a JPG or PNG.'; return; }
      if (f.size > 15 * 1024 * 1024) { upmsg.textContent = 'That image is over 15MB. Please choose a smaller one.'; return; }
      busy.hidden = false;
      var url = URL.createObjectURL(f), im = new Image();
      im.onload = function () {
        var sc = Math.min(1, 2400 / Math.max(im.naturalWidth, im.naturalHeight)), src = canvas(im.naturalWidth * sc, im.naturalHeight * sc);
        var sx = src.getContext('2d'); sx.fillStyle = '#fff'; sx.fillRect(0, 0, src.width, src.height); sx.drawImage(im, 0, 0, src.width, src.height);
        var alpha = canvas(im.naturalWidth * sc, im.naturalHeight * sc); alpha.getContext('2d').drawImage(im, 0, 0, alpha.width, alpha.height);
        URL.revokeObjectURL(url);
        var opts = { mode: 'line', detail: 50, invert: false, bg: true };
        var m = processImage(alpha, opts);
        busy.hidden = true;
        if (!m) { upmsg.textContent = 'We couldn\'t find anything to engrave in that image. Try turning off "Remove the background" or picking a clearer image.'; opts.bg = false; m = processImage(alpha, opts); if (!m) return; }
        state.objs = state.objs.filter(function (o) { return o.kind !== 'upload'; });
        var s = Math.min(AR * 0.6, 0.6 * m.height / m.width);
        add({ type: 'img', kind: 'upload', auto: true, mask: m, src: src, alphaSrc: alpha, opts: opts, s: s });
        if (Math.min(im.naturalWidth, im.naturalHeight) < 400) { upmsg.textContent = 'This image is quite small, so it may look rough when engraved. A larger version will give a sharper result.'; }
        else { upmsg.textContent = 'Image added. Adjust the settings below if you need to.'; upmsg.classList.add('mst__ok'); }
      };
      im.onerror = function () { busy.hidden = true; URL.revokeObjectURL(url); upmsg.textContent = 'We couldn\'t open that image. Please try a JPG or PNG.'; };
      im.src = url;
    }
    fileIn.addEventListener('change', function () { useFile(fileIn.files[0]); fileIn.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files[0]; useFile(f); });
    function upObj() { var o = selObj(); if (o && o.kind === 'upload') return o; return state.objs.filter(function (x) { return x.kind === 'upload'; })[0]; }
    var repT = 0;
    function reprocess(now) {
      var o = upObj(); if (!o || !o.alphaSrc) return;
      clearTimeout(repT);
      repT = setTimeout(function () {
        var m = processImage(o.alphaSrc, o.opts);
        if (!m) { upmsg.textContent = 'Those settings leave nothing to engrave. Try moving the Detail slider.'; return; }
        upmsg.textContent = ''; o.mask = m; commit();
      }, now ? 0 : 120);
    }
    qa('[data-mode]').forEach(function (b) { b.addEventListener('click', function () { var o = upObj(); if (!o) return; o.opts.mode = b.dataset.mode; reprocess(true); }); });
    q('[data-detail]').addEventListener('input', function () { var o = upObj(); if (!o) return; o.opts.detail = +this.value; reprocess(); });
    q('[data-bg]').addEventListener('change', function () { var o = upObj(); if (!o) return; o.opts.bg = this.checked; reprocess(true); });
    q('[data-inv]').addEventListener('change', function () { var o = upObj(); if (!o) return; o.opts.invert = this.checked; reprocess(true); });
    rights.addEventListener('change', function () { state.rights = rights.checked; if (rights.checked) msg.textContent = ''; });

    // Selection controls
    q('[data-size]').addEventListener('input', function () { var o = selObj(); if (!o) return; o.s = Math.max(0.03, this.value / 100 * AR); draw(); });
    q('[data-size]').addEventListener('change', commit);
    q('[data-rot]').addEventListener('input', function () { var o = selObj(); if (!o) return; o.r = +this.value; if (Math.abs(o.r) < 4) o.r = 0; draw(); });
    q('[data-rot]').addEventListener('change', commit);
    q('[data-center]').addEventListener('click', function () { var o = selObj(); if (!o) return; o.x = 0.5; o.y = AR / 2; commit(); });
    q('[data-front]').addEventListener('click', function () { var o = selObj(); if (!o) return; state.objs = state.objs.filter(function (x) { return x !== o; }).concat([o]); commit(); });
    q('[data-del]').addEventListener('click', function () { var o = selObj(); if (!o) return; state.objs = state.objs.filter(function (x) { return x !== o; }); sel = null; commit(); });
    function restoreHist() { var s = clone(hist[hi]); state.objs = s.objs; state.strokes = s.strokes; if (!selObj()) sel = null; draw(); }
    q('[data-undo]').addEventListener('click', function () { if (hi > 0) { hi--; restoreHist(); } });
    q('[data-redo]').addEventListener('click', function () { if (hi < hist.length - 1) { hi++; restoreHist(); } });
    q('[data-clear]').addEventListener('click', function () { if (isEmpty(state) || W.confirm('Clear everything and start again?')) { state.objs = []; state.strokes = []; sel = null; commit(); } });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { if (!q('[data-big]').hidden) closeBig(); else close(false); }
      if ((e.key === 'Delete' || e.key === 'Backspace') && D.activeElement === board && selObj()) { state.objs = state.objs.filter(function (x) { return x.id !== sel; }); sel = null; commit(); }
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'z') { e.preventDefault(); q(e.shiftKey ? '[data-redo]' : '[data-undo]').click(); }
    });

    // Big preview with zoom
    var zoomed = false;
    function openBig() { q('[data-big]').hidden = false; zoomed = false; q('[data-bigin]').style.transform = ''; q('[data-zoom]').textContent = 'Zoom in'; drawMini(); }
    function closeBig() { q('[data-big]').hidden = true; }
    q('[data-mini]').addEventListener('click', openBig);
    q('[data-see]').addEventListener('click', openBig);
    q('[data-hundo]').addEventListener('click', function () { q('[data-undo]').click(); });
    q('[data-hredo]').addEventListener('click', function () { q('[data-redo]').click(); });
    q('[data-clear2]').addEventListener('click', function () { q('[data-clear]').click(); });
    q('[data-bigclose]').addEventListener('click', function (e) { e.stopPropagation(); closeBig(); });
    q('[data-big]').addEventListener('click', function (e) { if (e.target === this) closeBig(); });
    q('[data-zoom]').addEventListener('click', function (e) {
      e.stopPropagation(); zoomed = !zoomed;
      var ty = (50 - zone.top) * 2.4;
      q('[data-bigin]').style.transform = zoomed ? 'scale(2.4) translateY(' + (ty / 2.4) + '%)' : '';
      this.textContent = zoomed ? 'Zoom out' : 'Zoom in';
    });

    // Close and finish
    function close(save) {
      D.documentElement.style.overflow = prevOverflow;
      W.removeEventListener('resize', sizeBoard);
      root.remove();
      if (!save && opts.onCancel) opts.onCancel();
    }
    q('[data-close]').addEventListener('click', function () { if (!dirty || W.confirm('Close without saving your changes?')) close(false); });
    q('[data-done]').addEventListener('click', function () {
      if (isEmpty(state)) { msg.textContent = 'Add something to your design first, or close to go back.'; return; }
      if (hasUpload(state) && !rights.checked) { setTab('upload'); msg.textContent = 'Please confirm you have the right to use the image you uploaded.'; rights.focus(); return; }
      var fresh = clone(state);
      close(true);
      if (opts.onDone) opts.onDone(fresh);
    });

    [miniImg, bigImg].forEach(function (i) { i.onload = drawMini; i.onerror = function () { if (opts.front && i.src.indexOf(opts.front) === -1) i.src = opts.front; }; i.src = opts.back || opts.front; });
    back.onload = function () { backOK = true; draw(); };
    back.onerror = function () {
      // If the image can't be loaded for sharing, load it plainly: the board only needs to show it
      var plain = new Image(); plain.onload = function () { back = plain; backOK = true; draw(); }; plain.src = opts.back || opts.front;
    };
    back.src = opts.back || opts.front;
    W.addEventListener('resize', sizeBoard);
    fontsReady().then(function () { sizeBoard(); });
    sizeBoard();
    setTab(opts.tab || (state.objs.some(function (o) { return o.kind === 'upload'; }) ? 'upload' : 'text'));
    board.tabIndex = 0;
    setTimeout(function () { q('[data-close]').focus(); }, 30);
  }

  W.MoyaStudio = { textState: textState, open: open, build: build, overlay: overlay, ratio: ratio, zoneRect: zoneRect, isEmpty: isEmpty, hasUpload: hasUpload, summary: summary, serialise: serialise, restore: restore, fromStrokes: fromStrokes, clone: clone, fontsReady: fontsReady };
})();
